import { motion } from "framer-motion";

function Sadanand() {
  return (
    <>
      {/* Page load animation */}
      <motion.div
        initial={{ width: "100vw", height: "100vh", borderRadius: 0, transformOrigin: "center" }}
        animate={{ width: 0, height: 0, borderRadius: "100%", transformOrigin: "center" }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        className="absolute top-1/2 left-1/2 bg-custom-ivory z-40 -translate-x-1/2 -translate-y-1/2"
      />

      <div className="flex justify-center px-3 sm:px-6 md:px-12 py-10 bg-custom-ivory">
        <div className="w-full max-w-4xl">
          <h1 className="text-2xl sm:text-3xl md:text-4xl text-center font-semibold text-custom-maroon mb-6">
            Kosh Kriya
          </h1>

          <h2 className="text-base sm:text-lg md:text-xl text-custom-yellow mb-4">
            The Synergy of Kriya and the Koshas.
          </h2>

          <p className="text-base sm:text-lg md:text-xl text-custom-yellow mb-6 text-justify break-words">
            The human being is comprised of five energetic sheaths (Koshas), from the physical to the blissful. Kriya, or specific yogic actions, are practices designed to purify and navigate these layers.
          </p>

          <ul className="list-disc list-inside text-base sm:text-lg md:text-xl text-custom-yellow mb-6 space-y-3">
            <li>
              <strong>Purifying the Outer Layers:</strong> Kriya uses breath control (pranayama) to cleanse the Annamaya (physical) and Pranamaya (energetic) Koshas, clearing blockages and preparing the body for deeper practice.
            </li>
            <li>
              <strong>Quieting the Mind:</strong> As the practice deepens, Kriya stills the mind (Manomaya Kosha), allowing for direct, intuitive knowledge to emerge from the Vijnanamaya (intellectual) Kosha.
            </li>
            <li>
              <strong>Reaching for Bliss:</strong> The ultimate goal is for Kriya to awaken the spiritual energy (Kundalini), guiding it through all the Koshas to reach the innermost Anandamaya (bliss) layer and attain a state of pure bliss (Sadanand). In essence, the Koshas are the spiritual map, and Kriya is the vehicle for the journey.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Sadanand;
